import TopDonationTypes from './TopDonationTypes';

export default TopDonationTypes;
